import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';

import { provideRouter } from '@angular/router';

import { appRoutes } from './app.routes';
import { AuthService } from './services/auth/auth.service';

// 🔐 Initialize auth BEFORE router starts
export function initializeAuth(auth: AuthService) {
  return () => auth.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideZoneChangeDetection({
      eventCoalescing: true,
    }),

    provideRouter(appRoutes),

    provideHttpClient(),

    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true,
    },

    {
      provide: LOCALE_ID,
      useValue: 'en-IN',
    },

    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'INR',
    },

    // Default Angular date pipe: still prefer IST when used elsewhere.
    // Order screens use IstDatePipe (naive UTC → Asia/Kolkata).
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        timezone: 'Asia/Kolkata',
      },
    },
  ],
};
